import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLegalPage } from "@/lib/servicesApi";
import { parseLegalBody } from "@/lib/legalText";
import { ArrowLeft } from "lucide-react";
import { useLang, useT } from "@/content/landing";
import { BrandLogo } from "@/components/BrandLogo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { Footer } from "./Footer";
export function LegalPage({
  doc
}) {
  const t = useT();
  const {
    lang
  } = useLang();
  const fallback = t.legal[doc];
  // undefined = still loading, null = use the static fallback, object = API page.
  const [page, setPage] = useState(undefined);
  useEffect(() => {
    let alive = true;
    setPage(undefined);
    getLegalPage(doc).then(p => alive && setPage(p && typeof p.body === "string" ? p : null)).catch(() => alive && setPage(null));
    return () => {
      alive = false;
    };
  }, [doc]);
  const blocks = page ? parseLegalBody(page.body) : [];
  const title = page && page.title ? page.title : fallback.title;
  const {
    intro,
    sections
  } = fallback;
  return <div className="min-h-screen bg-[#FAFBFC] font-sans antialiased">
      <header className="border-b border-black/5 bg-white">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between gap-3 px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5">
            <BrandLogo className="h-11" />
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            <Link to="/" className="hidden items-center gap-1.5 text-sm font-medium text-[#64748B] hover:text-[#0F172A] sm:inline-flex">
              <ArrowLeft size={15} aria-hidden /> {t.ui.backToHome}
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20">
        <h1 className="text-3xl font-bold text-[#0F172A]">{title}</h1>
        {page === undefined ? null : page ? <div className="mt-10" data-testid="legal-live">
            {blocks.map((b, i) => b.type === "h" ? <h2 key={i} className="mt-8 text-lg font-semibold text-[#0F172A]">{b.text}</h2> : <p key={i} className="mt-3 whitespace-pre-line text-sm leading-relaxed text-[#64748B]">{b.text}</p>)}
          </div> : <>
            <div className="mt-5 rounded-2xl border border-dashed border-black/15 bg-white p-4 text-sm text-[#94A3B8]">
              {t.ui.legalPlaceholder} {t.footer.disclaimer}
              {lang !== "de" && <> {t.ui.legalTranslationNote}</>}
            </div>
            <p className="mt-8 text-base leading-relaxed text-[#64748B]">{intro}</p>

            <div className="mt-10 space-y-8">
              {sections.map(s => <section key={s.heading}>
                  <h2 className="text-lg font-semibold text-[#0F172A]">{s.heading}</h2>
                  {s.body.map((p, i) => <p key={i} className="mt-3 text-sm leading-relaxed text-[#64748B]">
                      {p}
                    </p>)}
                </section>)}
            </div>
          </>}
      </main>

      <Footer />
    </div>;
}